import {getAxiosInstance} from "../../../../np-rest/rest";
import {snackActions} from "../../../../sc-utilities/SnackBar";

export const fetchPlanVersions = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/plan/count-versions", filterData);
            if (countRes.data && countRes.data.succeeded) {
                let listRes = await rest.post("/plan/list-versions", filterData);
                if (listRes.data && listRes.data.succeeded) {
                    return { data: listRes.data.result.data, count: countRes.data.result.data }
                }
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch plan versions."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: [], count: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch plan versions."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 }
        }
    }
}